import { motion } from "framer-motion";
import { COMPANY } from "@/config/company";

const MESSAGE = encodeURIComponent(
  "Hello Aadiyogis EXIM Traders, I'm interested in your agricultural commodities and would like a quote."
);
const HREF = `https://wa.me/${COMPANY.whatsapp}?text=${MESSAGE}`;

function WhatsAppGlyph({ size = 26 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
      <path d="M16.003 3.2c-7.06 0-12.8 5.74-12.8 12.8 0 2.257.59 4.463 1.712 6.41L3.2 28.8l6.57-1.72a12.74 12.74 0 0 0 6.233 1.59h.005c7.06 0 12.8-5.74 12.8-12.8s-5.74-12.67-12.805-12.67zm0 23.06h-.004a10.6 10.6 0 0 1-5.4-1.48l-.387-.23-4.02 1.053 1.073-3.92-.252-.402a10.56 10.56 0 0 1-1.62-5.64c0-5.86 4.77-10.63 10.637-10.63 2.84 0 5.51 1.108 7.52 3.118a10.56 10.56 0 0 1 3.114 7.52c0 5.865-4.77 10.63-10.63 10.63zm5.83-7.96c-.32-.16-1.89-.933-2.183-1.04-.293-.107-.507-.16-.72.16-.213.32-.826 1.04-1.013 1.253-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.57-1.586-.95-.847-1.59-1.893-1.777-2.213-.187-.32-.02-.493.14-.653.144-.143.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.734-.986-2.374-.26-.622-.523-.538-.72-.548l-.613-.01c-.213 0-.56.08-.853.4-.293.32-1.12 1.094-1.12 2.667s1.147 3.094 1.307 3.307c.16.213 2.253 3.44 5.46 4.826.763.33 1.36.527 1.824.674.766.244 1.464.21 2.016.127.615-.092 1.89-.773 2.156-1.52.267-.746.267-1.386.187-1.52-.08-.133-.293-.213-.613-.373z" />
    </svg>
  );
}

export default function WhatsAppButton() {
  return (
    <motion.a
      href={HREF}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      aria-label="Chat with us on WhatsApp"
      className="fixed bottom-6 left-6 z-[55] h-14 w-14 rounded-full bg-[#25D366] text-white shadow-2xl flex items-center justify-center"
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.92 }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.6, duration: 0.5 }}
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-40 animate-ping" style={{ animationDuration: "2.5s" }} />
      <span className="relative"><WhatsAppGlyph /></span>
    </motion.a>
  );
}
